import { render } from "./WorkflowDetailPage.vue?vue&type=template&id=3bac7425&scoped=true"
import script from "./WorkflowDetailPage.vue?vue&type=script&lang=js"
export * from "./WorkflowDetailPage.vue?vue&type=script&lang=js"

import "./WorkflowDetailPage.vue?vue&type=style&index=0&id=3bac7425&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bac7425"]])

export default __exports__